import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { companyInfo, serviceAreas } from '../mock';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer style={{ background: 'var(--bg-section)', borderTop: '1px solid var(--border-light)' }}>
      <div className="container py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              <Logo width={160} height={45} />
            </div>
            <p className="body-small mb-4">{companyInfo.tagline}</p>
            <div className="flex flex-col gap-2">
              <a href={`tel:${companyInfo.phoneRaw}`} className="flex items-center gap-2 text-sm" style={{ color: 'var(--text-secondary)' }}>
                <Phone size={16} />
                {companyInfo.phone}
              </a>
              <a href={`mailto:${companyInfo.email}`} className="flex items-center gap-2 text-sm" style={{ color: 'var(--text-secondary)' }}>
                <Mail size={16} />
                {companyInfo.email}
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="heading-3 mb-4" style={{ fontSize: '1rem' }}>Quick Links</h4>
            <ul className="flex flex-col gap-2">
              <li><Link to="/" className="body-small hover:text-accent-text transition-colors">Home</Link></li>
              <li><Link to="/services" className="body-small hover:text-accent-text transition-colors">Services</Link></li>
              <li><Link to="/areas" className="body-small hover:text-accent-text transition-colors">Service Areas</Link></li>
              <li><Link to="/about" className="body-small hover:text-accent-text transition-colors">About Us</Link></li>
              <li><Link to="/blog" className="body-small hover:text-accent-text transition-colors">Blog</Link></li>
              <li><Link to="/contact" className="body-small hover:text-accent-text transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="heading-3 mb-4" style={{ fontSize: '1rem' }}>Our Services</h4>
            <ul className="flex flex-col gap-2">
              <li><Link to="/services/rats-mice" className="body-small hover:text-accent-text transition-colors">Rats & Mice</Link></li>
              <li><Link to="/services/bed-bugs" className="body-small hover:text-accent-text transition-colors">Bed Bugs</Link></li>
              <li><Link to="/services/termites" className="body-small hover:text-accent-text transition-colors">Termites</Link></li>
              <li><Link to="/services/cockroaches" className="body-small hover:text-accent-text transition-colors">Cockroaches</Link></li>
              <li><Link to="/services" className="body-small hover:text-accent-text transition-colors font-semibold">View All Services →</Link></li>
            </ul>
          </div>

          {/* Hours of Operation */}
          <div>
            <h4 className="heading-3 mb-4" style={{ fontSize: '1rem' }}>Hours of Operation</h4>
            <ul className="flex flex-col gap-2">
              <li className="flex justify-between items-center">
                <span className="body-small">Monday</span>
                <span className="body-small font-semibold" style={{ color: 'var(--accent-text)' }}>Open 24 Hours</span>
              </li>
              <li className="flex justify-between items-center">
                <span className="body-small">Tuesday</span>
                <span className="body-small font-semibold" style={{ color: 'var(--accent-text)' }}>Open 24 Hours</span>
              </li>
              <li className="flex justify-between items-center">
                <span className="body-small">Wednesday</span>
                <span className="body-small font-semibold" style={{ color: 'var(--accent-text)' }}>Open 24 Hours</span>
              </li>
              <li className="flex justify-between items-center">
                <span className="body-small">Thursday</span>
                <span className="body-small font-semibold" style={{ color: 'var(--accent-text)' }}>Open 24 Hours</span>
              </li>
              <li className="flex justify-between items-center">
                <span className="body-small">Friday</span>
                <span className="body-small font-semibold" style={{ color: 'var(--accent-text)' }}>Open 24 Hours</span>
              </li>
              <li className="flex justify-between items-center">
                <span className="body-small">Saturday</span>
                <span className="body-small font-semibold" style={{ color: 'var(--accent-text)' }}>Open 24 Hours</span>
              </li>
              <li className="flex justify-between items-center">
                <span className="body-small">Sunday</span>
                <span className="body-small font-semibold" style={{ color: 'var(--accent-text)' }}>Open 24 Hours</span>
              </li>
            </ul>
            <div className="mt-3 p-2 rounded" style={{ background: 'var(--accent-wash)' }}>
              <p className="caption font-semibold text-center" style={{ color: 'var(--accent-text)' }}>
                🕐 24/7 Emergency Service Available
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-border-light flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="caption">
            © {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
          </p>
          <div className="flex gap-4">
            <Link to="/privacy" className="caption hover:text-accent-text transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="caption hover:text-accent-text transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;